import { styled, Paper } from '@mui/material';

export const Container = styled(Paper)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: '0px 24px',
}));

export const Payment = styled('span')<{ paid: boolean }>(({ theme, paid }) => ({
  color: paid ? theme.palette.success.main : theme.palette.error.main,
}));

export const TypeContainer = styled('div')(() => ({
  display: 'flex',
  gap: 16,
}));

export const SortFilterToolbar = styled('div')`
  display: flex;
  align-items: center;
  gap: 24px;
  padding-bottom: 12px;
`;
